import { toast, updateBaseOptions } from '@ui-kit/scripts/configs/notify-config'
import { TOASTER_TIME } from '@/scripts/app-configs/constants'

updateBaseOptions({
  timeout: TOASTER_TIME,
  pauseOnFocusLoss: false,
})

const $notify = toast

export { $notify }

export default {
  install(app) {
    app.config.globalProperties.$notify = $notify
  },
}
